import { API, API_POST } from "../../../Config";

export const handleUpdateRecipe = (payload, id) => {
  const formData = new FormData();
  console.log("p", payload);
  Array.from(payload.images).forEach((img, idx) => {
    formData.append(`r_images[${idx}]`, img);
  });
  if (payload.remove_photos) {
    formData.append("remove_photos", payload.remove_photos);
  }
  formData.append("title", payload.title);
  formData.append("description", payload.description);
  formData.append("recipe_type", payload.recipe_type);
  formData.append("id", id);

  return API_POST(API.EditRecipe, formData);
};
